<template>
    <div class="shop-wrapper">

        <div id="order-details" class="section">
            <!-- Container -->
            <div class="container">

                <!-- Orders Grid -->
                <div class="columns account-header">
                    <div class="column main-column is-tablet-landscape-padded">
                        <div class="account-title">
                            <a class="title-back" @click="goBack">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
                            </a>
                            <h2>Detalle de Intención de Pedido</h2>
                        </div>
                        <!--Header-->
                        <div class="order-details-wrap">
                            <div class="order-details-header">
                                <div class="left">
                                    <span id="order-details-id"># <var>{{ $route.params.id }}</var></span>
                                    <span id="order-details-date">
                                        Emitido el <var>{{ record.updated_at | dateLatin | dateStringDetailed}}</var>
                                    </span>
                                </div>
                                <div class="right" v-if="record.id_vendedor">
                                    <div class="inner-meta">
                                        <span>Controlado Por</span>
                                        <span id="order-details-contact">Cod. {{record.id_vendedor}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="order-stats">
                                <div class="columns">
                                    <div class="column is-3">
                                        <div id="payment-tile" class="order-stat is-done">
                                            <h3>Forma de Pago</h3>
                                            <div class="order-stat-inner">
                                                <div class="icon-container">
                                                    <img :src="require('../../assets/images/payment.svg')" alt="">
                                                </div>
                                                <div class="meta" v-if="record.tipo_forma_pago">
                                                    <span>{{record.tipo_forma_pago}}</span>
                                                    <span v-if="record.dto_forma_pago != ''">
                                                        Descuento % {{record.dto_forma_pago  | MoneyFormat }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-3">
                                        <div id="shipping-tile" class="order-stat is-done">
                                            <h3>Descuento por Volumen</h3>
                                            <div class="order-stat-inner">
                                                <div class="icon-container">
                                                    <img :src="require('../../assets/images/bag.svg')" alt="">
                                                </div>
                                                <div class="meta">
                                                    <span v-if="record.tipo_dto_volumen">{{record.tipo_dto_volumen}}</span>
                                                    <span v-else>No Aplica</span>
                                                    <span v-if="record.tipo_dto_volumen && record.dto_volumen > 0">
                                                        Descuento % {{record.dto_volumen  | MoneyFormat }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="column is-3">
                                        <div id="status-tile" class="order-stat" :class="record.pago_anticipado != 0 ? 'is-done' : 'has-error'">
                                            <h3>Pago Anticipado</h3>
                                            <div class="order-stat-inner">
                                                <div class="icon-container">
                                                    <img :src="require('../../assets/images/status.svg')" alt="">
                                                    <div class="indicator">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x error"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x warning"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                    </div>
                                                </div>
                                                <div class="meta">
                                                    <span v-if="record.pago_anticipado != 0">Activado</span>
                                                    <span v-else>No Activado</span>

                                                    <span v-if="record.pago_anticipado != 0">
                                                        Descuento % {{record.dto_pago_anticipado  | MoneyFormat }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="column is-3">
                                        <div id="status-tile" class="order-stat" :class="record.pago_anticipado != 0 ? 'is-done' : 'has-error'">
                                            <h3>Descuento Adicional</h3>
                                            <div class="order-stat-inner">
                                                <div class="icon-container">
                                                    <img :src="require('../../assets/images/status.svg')" alt="">
                                                    <div class="indicator">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x error"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x warning"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                                    </div>
                                                </div>
                                                <div class="meta">
                                                    <span v-if="record.dto_anticipado != 0">Activado</span>
                                                    <span v-else>No Activado</span>

                                                    <span v-if="record.dto_anticipado != 0">
                                                        Descuento % {{record.dto_adicional | MoneyFormat }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="order-body">
                                <div class="columns">
                                    <div class="column is-8">
                                        
                                        <div class="left-side-header">
                                            <h3>Productos</h3>
                                        </div>

                                        <div class="flex-table">
                                            <!--Table header-->
                                            <div class="flex-table-header">
                                                <span class="product"><span>Producto</span></span>
                                                <span class="quantity">Cantidad</span>
                                                <span class="price">Precio</span>
                                                <span class="discount">Descuento</span>
                                                <span class="total">Total</span>
                                            </div>
                                       
                                            <div class="flex-table-item product-container" data-product-id="{reg.id}" 
                                                v-for="reg in record.details" v-bind:key="`estado-${reg.id}`">
                                                <div class="product">
                                                    <span class="product-details-link product-name">{{reg.modelo}}</span>
                                                </div>
                                                <div class="quantity">
                                                    <span>{{reg.cantidad}}</span>
                                                </div>
                                                <div class="price">
                                                    <span class="has-price">{{reg.precio_unitario  | MoneyFormat }}</span>
                                                </div>
                                                <div class="discount">
                                                    <span class="has-price">{{reg.Porc_Bonif}}</span>
                                                </div>
                                                <div class="total">
                                                    <span class="has-price">{{reg.precio_acumulado  | MoneyFormat }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="flex-table">
                                            <div class="flex-table-item product-container">
                                                <div class="observation-title">
                                                    Observaciones:
                                                </div>
                                                <div class="observation-content">
                                                    {{record.observacion}}
                                                </div>                                            
                                            </div>                                        
                                        </div>                                        

                                    </div>

                                    <div class="column is-4">
                                        <div class="payment-info">
                                            <h3 class="info-title">Informacion Estimada de Pago</h3>
                                            <div class="payment-block">
                                                <span>Subtotal</span>
                                                <span id="order-subtotal-value" class="has-price">{{record.sub_total  | MoneyFormat }}</span>
                                            </div>
                                            <div class="payment-block" v-if="record.monto_forma_pago > 0">
                                                <span>Dto. Financiero (% {{record.dto_forma_pago | MoneyFormat }})</span>
                                                <span id="order-shipping-value" class="has-price">
                                                    {{ record.monto_forma_pago  | MoneyFormat }}
                                                </span>
                                            </div>
                                            <div class="payment-block" v-if="record.monto_anticipo > 0">
                                                <span>Dto. Anticipo (% {{record.dto_pago_anticipado | MoneyFormat }})</span>
                                                <span id="order-shipping-value" class="has-price">
                                                    {{ record.monto_anticipo  | MoneyFormat }}
                                                </span>
                                            </div>
                                            <div class="payment-block" v-if="record.monto_volumen > 0">
                                                <span>Dto. Volumen (% {{record.dto_volumen | MoneyFormat }})</span>
                                                <span id="order-shipping-value" class="has-price">
                                                    {{ record.monto_volumen  | MoneyFormat }}
                                                </span>
                                            </div>
                                            <div class="payment-block" v-if="record.monto_dto_adicional > 0">
                                                <span>Dto. Adicional (% {{record.dto_adicional | MoneyFormat }})</span>
                                                <span id="order-shipping-value" class="has-price">
                                                    {{ record.monto_dto_adicional  | MoneyFormat }}
                                                </span>
                                            </div>
                                            <div class="payment-block" v-if="record.monto_total_dto > 0">
                                                <span>Descuento Total</span>
                                                <span id="order-shipping-value" class="has-price">
                                                    {{ record.monto_total_dto  | MoneyFormat }}
                                                </span>
                                            </div>
                                            <div class="payment-block">
                                                <span class="is-bold">Total</span>
                                                <span id="order-grandtotal-value" class="has-price is-bold">{{record.total  | MoneyFormat }}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>   
</template>

<script>

import { mapGetters } from 'vuex' 
// import navigation from '../components/navigation'

export default {
    name: 'OrderIntentionsDetail',
    beforeCreate(){
        this.$store.dispatch('intentions/getOrderSelected',{'id': this.$route.params.id})
    },    
    computed: {
        ...mapGetters({
            record: 'intentions/selected',
            errors: 'auth/errors',
        }),
    },
    methods: {
        goBack () {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/')
        },
    }
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px;
}
.table-wrapper{
    overflow-x: auto;
}

svg.svg-button{
    width: 18px;
    height: 18px;
    -webkit-transition: all .3s;
    transition: all .3s;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    stroke-width: 1.2px;
}
.observation-title, .observation-content{
    display: block;
    margin-left: 12px;
    max-width: 360px;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.8rem;
}
.observation-title{
    color: #4a4a4a;
}
.observation-content{    
    color: #999;
}
</style>